export * from "./tab-panel.template";
export * from "./tab-panel";
